import React from 'react';
import PropTypes from 'prop-types';
import withBreadcrumbs from 'react-router-breadcrumbs-hoc';
import { makeStyles } from '@mui/styles';
import { Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import lowerCase from 'lodash/lowerCase';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'row',
    margin: theme.spacing(2),
  },

  arrow: {
    margin: 4,
  },
}));

const BreadCrumbs = ({ breadcrumbs }) => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <div className={classes.root}>
      {breadcrumbs.map(({ breadcrumb, match }, index) => (
        <Typography
          key={match.url}
          component="h2"
          gutterBottom
          variant="overline">
          <RouterLink to={match.url || ''}>
            {t(lowerCase(breadcrumb.props.children))}
          </RouterLink>
          <span className={classes.arrow}>
            {index < breadcrumbs.length - 1 && '>'}
          </span>
        </Typography>
      ))}
    </div>
  );
};

BreadCrumbs.propTypes = {
  breadcrumbs: PropTypes.array.isRequired,
};

export default withBreadcrumbs(
  [
    {
      path: '/user-management/groups/:groupId',
      breadcrumb: 'Group Details',
    },
    {
      path: '/configuration/tenants/:tenantId',
      breadcrumb: 'Tenant Details',
    },
    {
      path: '/configuration/workflows/:workflowId',
      breadcrumb: 'Workflow Details',
    },
    {
      path: '/session-management/sessions/:sessionId',
      breadcrumb: 'Session Details',
    },
    {
      path: '/session-management/validation/:sessionId',
      breadcrumb: 'Session Details',
    },
    {
      path: '/session-management/partially-rejected/:sessionId',
      breadcrumb: 'Session Details',
    },
    {
      path: '/configuration/sso-profiles/:id',
      breadcrumb: 'SSO Profile',
    },
  ],
  {
    excludePaths: [
      '/user-management',
      '/profile',
      '/configuration',
      '/session-management',
    ],
  },
)(BreadCrumbs);
